var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.items, function(v, i) {
        return [
          v.flag === "hot"
            ? _c("i", {
                key: i,
                staticClass: "iconfont icon-custom-hot",
                staticStyle: { color: "#FF5722", "margin-right": "2px" },
                attrs: { title: "热门" }
              })
            : _vm._e(),
          _vm._v(" "),
          v.flag === "dv"
            ? _c("i", {
                key: i,
                staticClass: "iconfont icon-vimeo2",
                staticStyle: { color: "#FFC107", "margin-right": "2px" },
                attrs: { title: "大V" }
              })
            : _vm._e(),
          _vm._v(" "),
          v.flag === "jian"
            ? _c("i", {
                key: i,
                staticClass: "iconfont icon-jian---",
                staticStyle: { color: "#FF9800", "margin-right": "2px" },
                attrs: { title: "编辑推荐" }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32a4d5ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a4d5ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_widget/FrontFlag.vue
// module id = null
// module chunks = 